const e = {
  name: "RiskDanger",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15.5,0h3.7L17,16h17v2.4L14.4,40h-2.6L14,24H0v-2.3L15.5,0z M16.5,2L2.2,22h14l-2,15.2L31.7,18H14.7l2.1-16
			H16.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as RiskDanger
};
